<div class="page-header">
    <div class="header-row">
        <!-- Actions -->
        <div></div><!-- spacer -->
        <div class="page-actions">
            <button class="btn-secondary" (click)="openModalG()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                </svg>
                Send Notification
            </button>
            <button class="btn btn-primary" (click)="addDriver()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                </svg>
                Add Driver
            </button>
        </div>
    </div>
</div>
<div class="driver-list-container">
    <!-- Removed legacy spinner in favor of Skeleton UX -->

    <!-- PAGE HEADER -->

    <!-- FILTERS SECTION -->
    <div class="filters-section">
        <div class="filters-row">
            <!-- Filter Chips -->
            <div *ngFor="let chip of filterChips" class="filter-chip" [class.active]="chip.active"
                (click)="onFilterClick(chip)">
                {{ chip.label }}
                <span class="count">{{ chip.count }}</span>
            </div>

            <!-- Search Box (Right Side) -->
            <div class="search-box">
                <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                </svg>
                <input type="text" class="search-input" placeholder="Search drivers..." [(ngModel)]="searchQuery"
                    (input)="onSearch()">
                <svg *ngIf="cross" (click)="clearText()" class="cross-icon" width="16" height="16"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
        </div>
    </div>

    <!-- TABLE SECTION -->
    <div class="table-section">
        <div class="table-wrapper">
            <table class="driver-table">
                <thead>
                    <tr>
                        <th>Driver</th>
                        <th>Assigned Orders</th>
                        <th>Completed Deliveries</th>
                        <th>Last Delivery Time</th>
                        <th>Time Back Warehouse</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody *ngIf="!isLoading || filteredDrivers.length > 0">
                    <tr *ngFor="let driver of filteredDrivers">
                        <!-- Driver Cell -->
                        <td>
                            <div class="driver-cell">
                                <div class="avatar-container">
                                    <div class="driver-avatar" [class]="driver?.avatarClass">
                                        <!-- Show profile image if available -->
                                        <img *ngIf="driver?.profile_image" [src]="driver.profile_image"
                                            class="driver-image" alt="Driver Image" />
                                        <!-- Show initials as fallback -->
                                        <span *ngIf="!driver?.profile_image">{{ getDriverInitials(driver) }}</span>
                                    </div>
                                    <!-- HD Badge Overlay on Avatar -->
                                    <span class="badge-hd-overlay" *ngIf="driver?.groups?.[0]?.name?.includes('Head')">
                                        HD
                                    </span>
                                </div>

                                <div class="driver-info">
                                    <div class="driver-name">
                                        <span class="name-text-wrap" [title]="getFullName(driver)">{{
                                            getFullName(driver) }}</span>
                                    </div>
                                    <div class="driver-status" [class.offline]="!driver.is_online"
                                        [class.online]="driver.is_online">
                                        {{ driver.is_online ? 'Online' : 'Offline' }}
                                    </div>
                                </div>
                            </div>
                        </td>

                        <!-- Assigned Orders -->
                        <td>{{ driver.assigned_orders_count }}</td>

                        <!-- Completed Deliveries -->
                        <td>{{ driver.completed_deliveries_count }}</td>

                        <!-- Last Delivery Time -->
                        <td
                            *ngIf="driver.drivertime && driver.drivertime.length > 0 && driver.drivertime[0].last_delivery_time">
                            {{ formatETDA(driver.drivertime[0].last_delivery_time)}}</td>
                        <td
                            *ngIf="!(driver.drivertime && driver.drivertime.length > 0 && driver.drivertime[0].last_delivery_time)">
                            --</td>

                        <!-- Time Back Warehouse -->
                        <td
                            *ngIf="driver.drivertime && driver.drivertime.length > 0 && driver.drivertime[0].time_back_warehouse">
                            {{ formatETDA(driver.drivertime[0].time_back_warehouse)}}
                        </td>

                        <td
                            *ngIf="!(driver.drivertime && driver.drivertime.length > 0 && driver.drivertime[0].time_back_warehouse)">
                            --</td>

                        <!-- Status -->
                        <td>
                            <span class="status-badge" [ngClass]="driver.is_active ? 'active' : 'inactive'"
                                (click)="goToDriverDetails(driver.id)">
                                {{ (driver.is_active ? 'Active' : 'In-Active') | uppercase }}
                            </span>

                        </td>

                        <!-- Actions -->
                        <td>
                            <div class="actions-cell">
                                <!-- Phone -->
                                <div class="contact-trigger-wrapper">
                                    <button class="action-btn phone-btn" title="Call" (click)="callDriver(driver, $event)"
                                        [class.active]="activeContactId === driver.id">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="2" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                        </svg>
                                    </button>

                                    <!-- Contact Popover -->
                                    <div class="contact-popover" *ngIf="activeContactId === driver.id" (click)="$event.stopPropagation()">
                                        <div class="popover-arrow"></div>
                                        <div class="popover-header">
                                            <span class="popover-name">{{ driver.first_name }} {{ driver.last_name }}</span>
                                            <span class="popover-phone">{{ getDriverPhone(driver) }}</span>
                                        </div>
                                        <div class="popover-actions">
                                            <button class="popover-btn call" (click)="initiateCall(getDriverPhone(driver), $event)" title="Call Now">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                                                </svg>
                                            </button>
                                            <button class="popover-btn whatsapp" (click)="openWhatsApp(getDriverPhone(driver), $event)" title="WhatsApp Chat">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.06 3.973L0 16l4.14-1.086c1.162.634 2.478.969 3.811.969h.005a7.862 7.862 0 0 0 5.86-2.569 7.854 7.854 0 0 0 2.23-5.611c.002-2.112-.822-4.095-2.316-5.592h-.001zm-5.607 11.458h-.003a6.55 6.55 0 0 1-3.342-.915l-.24-.143-2.484.652.662-2.42-.156-.248a6.539 6.539 0 0 1-1.003-3.484c.002-3.605 2.942-6.545 6.548-6.545a6.548 6.548 0 0 1 4.632 1.92 6.548 6.548 0 0 1 1.916 4.636c-.002 3.605-2.942 6.545-6.548 6.545zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.089-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                                </svg>
                                            </button>
                                            <button class="popover-btn copy" (click)="copyToClipboard(getDriverPhone(driver), $event, driver.id)" title="Copy Number">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                                                </svg>
                                            </button>
                                        </div>
                                        <div class="copied-badge" *ngIf="showCopiedId === driver.id">
                                            <span>Copied!</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Notification -->
                                <button class="action-btn notification-btn" title="Send Notification"
                                    (click)="openModal(driver.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                                    </svg>
                                </button>

                                <!-- Edit  (click)="editDriver(driver)"-->
                                <button class="action-btn edit-btn" title="Edit" (click)="editDriver(driver)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                    </svg>
                                </button>

                                <!-- Delete -->
                                <button class="action-btn delete-btn" title="Delete" (click)="deleteDriver(driver.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke-width="2" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                    </svg>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- No Results -->
                    <tr *ngIf="filteredDrivers?.length === 0">
                        <td colspan="7" style="text-align: center; padding: 40px; color: #9ca3af;">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                style="width: 48px; height: 48px; margin: 0 auto 16px; opacity: 0.5;">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                            </svg>
                            <div style="font-size: 16px; font-weight: 500; margin-bottom: 4px;">No drivers found</div>
                            <div style="font-size: 14px;">Try adjusting your search or filters</div>
                        </td>
                    </tr>
                </tbody>

                <!-- Skeleton Rows -->
                <tbody *ngIf="isLoading && filteredDrivers.length === 0">
                    <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]">
                        <td>
                            <div class="driver-cell">
                                <div class="skeleton-avatar"></div>
                                <div class="driver-info">
                                    <div class="skeleton-line" style="width: 120px; height: 14px; margin-bottom: 8px;">
                                    </div>
                                    <div class="skeleton-line" style="width: 60px; height: 12px;"></div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="skeleton-line full"></div>
                        </td>
                        <td>
                            <div class="skeleton-line full"></div>
                        </td>
                        <td>
                            <div class="skeleton-line full"></div>
                        </td>
                        <td>
                            <div class="skeleton-line full"></div>
                        </td>
                        <td>
                            <div class="skeleton-badge"></div>
                        </td>
                        <td>
                            <div class="actions-cell">
                                <div class="skeleton-icon-btn"></div>
                                <div class="skeleton-icon-btn"></div>
                                <div class="skeleton-icon-btn"></div>
                                <div class="skeleton-icon-btn"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- PAGINATION FOOTER -->
    <div class="pagination-footer">
        <!-- <div class="pagination-info">
            {{ getPaginationInfo() }}
        </div> -->

        <div class="pagination-controls">
            <button class="nav-arrow" [disabled]="currentPage === 1" (click)="goToPreviousPage()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </button>

            <div class="pagination-info">
                {{ getPaginationInfo() }}
                <!-- Page {{ currentPage }} of {{ totalPages }} -->
            </div>

            <button class="nav-arrow" [disabled]="currentPage === totalPages" (click)="goToNextPage()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </button>
        </div>
    </div>

</div>
<!-- SEND NOTIFICATION MODAL -->
<div *ngIf="isModalOpen" class="modal show" (click)="onBackdropClick($event)">
    <div class="modal-content">
        <div class="modal-header">
            <h2 class="modal-title">
                <svg class="modal-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                    stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                </svg>
                Send Notification
            </h2>
            <button class="modal-close" (click)="closeModal()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="form-group">
                <label class="form-label">
                    <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                    </svg>
                    Send To
                    <span class="required">*</span>
                </label>
                <div class="recipient-type-toggle">
                    <!-- <button class="toggle-option" 
                    [class.active]="recipientType === 'customers'"
                    (click)="toggleRecipientType('customers')">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="toggle-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
              Customers
            </button> -->
                    <button class="toggle-option" [class.active]="recipientType === 'drivers'"
                        (click)="toggleRecipientType('drivers')">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="toggle-icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                        </svg>
                        Drivers
                    </button>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">
                    <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                    </svg>
                    Message
                    <span class="required">*</span>
                </label>
                <textarea class="modal-textarea" placeholder="Enter your message here..." [maxlength]="maxChars"
                    [(ngModel)]="messageText" (input)="updateCharCount()">
                </textarea>
                <div class="error-text" *ngIf="showError">
                    Message is required
                </div>
                <div class="char-count" [ngClass]="getCharCountClass()">
                    <span>{{ charCount }}</span> / {{ maxChars }}
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">
                    <svg class="label-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke-width="2" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                    </svg>
                    Attachments
                    <span class="optional">(Optional)</span>
                </label>
                <input type="file" #fileInput class="file-input" multiple accept="image/*"
                    (change)="onFileSelect($event)">
                <label for="fileInput" class="file-upload-btn" (click)="fileInput.click()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>
                    Add Files
                </label>
                <div class="file-preview-list">
                    <div *ngFor="let preview of filePreviews; let i = index" class="file-preview-item">
                        <img [src]="preview.url" [alt]="preview.file.name">
                        <button class="file-preview-remove" (click)="removeFile(i)" type="button">×</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn-secondary" (click)="closeModal()">Cancel</button>
            <button class="btn-primary" (click)="sendNotification()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />
                </svg>
                Send Notification
            </button>
        </div>
    </div>
</div>